/**
 * @generated SignedSource<<cb336c9b818cfcf73150dda0a69f1661>>
 * @relayHash 05d026a4c290427fec85b20e9e253f6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e788b39841528205113de279e3af9cda7755796117b76386ac89452e2087363

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedSummaryQuery } from './decomposedSummaryQuery.graphql';

const node: PreloadableConcreteRequest<decomposedSummaryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9e788b39841528205113de279e3af9cda7755796117b76386ac89452e2087363",
    "metadata": {},
    "name": "decomposedSummaryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
